const icon = require('vue-svgicon');
icon.register({
    'trash': {
        width: 20,
        height: 20,
        viewBox: '0 0 20 20',
        data: `<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M17.222 4.444h.555a.556.556 0 100-1.11h-5V1.666a.556.556 0 00-.555-.556H7.777a.556.556 0 00-.555.556v1.666h-5a.556.556 0 000 1.111h.556v13.334c0 .613.497 1.11 1.11 1.11h12.223c.613 0 1.11-.497 1.11-1.11V4.444zM8.333 2.222h3.333v1.111H8.333v-1.11zm7.778 2.222H3.889v12.778c0 .307.249.555.555.555h11.111a.556.556 0 00.556-.555V4.444zm-2.223 3.89h-1.11V15h1.11V8.333zM9.445 7.22h1.111V15h-1.11V7.221zM7.222 8.333H6.11V15h1.11V8.333z" _fill="#000"/>`,
    },
});
